<template lang="pug">
.contentComponent(:class="contentClasses")
  router-view
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

export default {
  setup () {
    const route = useRoute()
    const isHomepage = computed(() => route.name === 'Home')
    const contentClasses = computed(() => ({ _homepage: isHomepage.value }))
    return { contentClasses }
  }
}
</script>

<style lang="sass" scoped>
.contentComponent
  width: 100%
  margin: 0 auto
  max-width: $appMaxWidth
  padding: 6*$u $appSidePaddingDesktop 25*$u
  @media (max-width: $padWidth)
    padding: 6*$u $appSidePaddingMobile 20*$u
  @media (max-width: $mobileWidth)
    padding-bottom: 15*$u

  &._homepage
    padding-top: 0
    padding-bottom: 0
</style>
